module.exports = __webpack_public_path__ + "static/media/f3000kz.93bf25c9.pdf";